<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">

<app-sub-header [pageTitle]="getPageTitle()"></app-sub-header>

<div class="padded-container">
        <dx-button
          class="full-width-button"
          text="{{ 'AddNewDamage' | translate }}"
          type="default"
          (onClick)="pickAddNew()"
        ></dx-button>
        <dx-button
          class="full-width-button"
          text="{{ 'ViewRecordedDamage' | translate }}"
          type="default"
          [disabled]="true"
          (onClick)="pickView()"
        ></dx-button>
        <dx-button
          class="full-width-button"
          text="{{ 'Back' | translate }}"
          type="default"
          stylingMode="contained"
          (onClick)="backClick()"
        ></dx-button>
  </div>
</div>